import gql from "graphql-tag";

export const hasTimeRegistrationApprovalAccessQuery = gql`
  query hasTimeRegistrationApprovalAccess {
    hasTimeRegistrationApprovalAccess
  }
`;
